import { ShipmentCommentContract } from "../domain/contracts/shipment_comment_contract";
import { shipmentCommentEntity } from "../domain/entities/shipment_comment";
import http from "../../../plugins/http-common"
// import i18n from "../../../../i18n";

export const HttpShipmentCommentRepository = {
    ...ShipmentCommentContract,
    model: shipmentCommentEntity,

    async upload_comments(file, shipments_type) {

        const formData = new FormData();
        formData.append('file', file);
        formData.append('shipments_type', shipments_type);

        const res = await http.post('create_shipment_comments', formData, { headers: { 'Content-Type': 'multipart/form-data' } } );
         
        return res;
    }
}